import React, { useState } from 'react';
import './RegisterPage.css';
import landingLogo from "../../assets/login1Logo.png";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const RegisterPage = () => {
  const history = useNavigate();

  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    contactNumber: '',
    password: '',
    confirmPassword: '',
    company: '',
    terms: false
  });

  const [formErrors, setFormErrors] = useState({});
  const [passwordVisibility, setPasswordVisibility] = useState({
    password: false,
    confirmPassword: false
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const togglePasswordVisibility = (field) => {
    setPasswordVisibility((prev) => ({
      ...prev,
      [field]: !prev[field]
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const errors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const contactRegex = /^[0-9]{10,15}$/;

    if (!formData.fullName) errors.fullName = "Required";
    if (!formData.email || !emailRegex.test(formData.email)) errors.email = "Invalid email";
    if (!formData.contactNumber || !contactRegex.test(formData.contactNumber)) errors.contactNumber = "Contact must be 10–15 digits";
    if (!formData.password) errors.password = "Required";
    if (!formData.confirmPassword) errors.confirmPassword = "Required";
    if (formData.password !== formData.confirmPassword) errors.confirmPassword = "Passwords do not match";
    if (!formData.company) errors.company = "Required";
    if (!formData.terms) errors.terms = "Please agree to terms";

    setFormErrors(errors);

    if (Object.keys(errors).length > 0) {
      setIsSubmitting(false);
      return;
    }

    try {
      const res = await axios.post("https://metalzulu-backend.onrender.com/api/v1/users/register", formData);
      alert(res.data.message || "Registration successful!");
      history("/otp", { state: { email: formData.email } });
    } catch (error) {
      alert(error.response?.data.message || "Registration failed");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="page-wrapper">
      <div className="register-container">
        <div className="logo-container">
          <div className="logo">
            <img src={landingLogo} alt="Logo" />
          </div>
        </div>

        <form id="registerForm" onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="input-field">
              <input
                type="text"
                name="fullName"
                placeholder="Full Name"
                value={formData.fullName}
                onChange={handleInputChange}
              />
              {formErrors.fullName && <span className="error">{formErrors.fullName}</span>}
            </div>

            <div className="input-field">
              <input
                type="email"
                name="email"
                placeholder="Email Address"
                value={formData.email}
                onChange={handleInputChange}
              />
              {formErrors.email && <span className="error">{formErrors.email}</span>}
            </div>
          </div>

          <div className="form-row">
            <div className="input-field">
              <input
                type={passwordVisibility.password ? "text" : "password"}
                name="password"
                placeholder="Password"
                value={formData.password}
                onChange={handleInputChange}
              />
              <span className="toggle-password" onClick={() => togglePasswordVisibility('password')}>
                {passwordVisibility.password ? '👁️‍🗨️' : '👁️'}
              </span>
              {formErrors.password && <span className="error">{formErrors.password}</span>}
            </div>

            <div className="input-field">
              <input
                type={passwordVisibility.confirmPassword ? "text" : "password"}
                name="confirmPassword"
                placeholder="Confirm Password"
                value={formData.confirmPassword}
                onChange={handleInputChange}
              />
              <span className="toggle-password" onClick={() => togglePasswordVisibility('confirmPassword')}>
                {passwordVisibility.confirmPassword ? '👁️‍🗨️' : '👁️'}
              </span>
              {formErrors.confirmPassword && <span className="error">{formErrors.confirmPassword}</span>}
            </div>
          </div>

          <div className="form-row">
            <div className="input-field">
              <input
                type="tel"
                name="contactNumber"
                placeholder="Contact Number"
                value={formData.contactNumber}
                onChange={handleInputChange}
              />
              {formErrors.contactNumber && <span className="error">{formErrors.contactNumber}</span>}
            </div>

            <div className="input-field">
              <input
                type="text"
                name="company"
                placeholder="Enter Company Name"
                value={formData.company}
                onChange={handleInputChange}
              />
              {formErrors.company && <span className="error">{formErrors.company}</span>}
            </div>
          </div>

          <div className="terms-checkbox">
            <input
              type="checkbox"
              name="terms"
              checked={formData.terms}
              onChange={handleInputChange}
            />
            <label htmlFor="terms">
              I agree to the <a href="#">Terms of Service</a> and <a href="#">Privacy Policy</a>
            </label>
            {formErrors.terms && <span className="error">{formErrors.terms}</span>}
          </div>

          <button type="submit" className="btn-register" disabled={isSubmitting}>
            {isSubmitting ? 'Registering...' : 'Register'}
          </button>
        </form>

        <div className="register-footer">
          <p>Already have an account? <a href="/login">Login</a></p>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
